import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index.js";
import Signin from "../views/Auth/Signin.vue";
import HomeDashboard from "../views/Auth/HomeDashboard.vue";
import Accounts from "../views/Accounts/Accounts.vue";
import Roles from "../views/Accounts/Roles.vue";
import UserFields from "../views/Accounts/UserFields.vue";
import AssignPermissions from "../views/Permissions/AssignPermissions.vue";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: HomeDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/accounts",
    name: "Accounts",
    component: Accounts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/userFields",
    name: "UserFields",
    component: UserFields,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/roles/permissions/:roleId",
    name: "Manage Permissions",
    component: AssignPermissions,
  },
];
const router = createRouter({
  history: createWebHistory("/"),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const isAuth = store.getters["auth/isAuthenticated"];

  if (to.meta.requiresAuth && !isAuth) {
    return next("/signin");
  }

  next();
});

export default router;
